import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { Link, useNavigate } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";

import DataTable from "react-data-table-component";
import DeleteConfirmationModal from "../../../components/Modal/DeleteConfirmation";
import { checkUserPermission } from "../../../common/UserPermission";

//--------Material React Table------//
import { MaterialReactTable } from "material-react-table";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import { Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";
import { MenuItem } from "@mui/material";
import {
  ERROR_EXISTS,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../common/Constant";
import { toastError, toastSuccess } from "../../../common/Toast";

let PERMISSION_ADD = "/manage-locations";
let PERMISSION_EDIT = "/manage-locations/:id";
let PERMISSION_DELETE = "delete-locations";
let PERMISSION_DELETED_LOCATIONS = "/deleted-locations";

const ManageSubCompany = () => {
  let selectData = [];

  const token = localStorage.getItem("Token");

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
    useState("");
  const [filtertext, setFiltertext] = useState("");

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  //popup on delete
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const navigate = useNavigate();



  //   Get all Suppliers data
  const handleListData = () => {
    setLoading(true);
    axios
      .get(`${config.locationBaseUrl}/locations/getsubcompany`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log(res, "jcjdncjdncjdncjdnc");
        setData(res.data.ResponseData);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };

  useEffect(() => {
    handleListData();
  }, []);

    const handleDeletePopup = (id) => {
    let payload = {
      id: id,
    };
    axios
      .post(`${config.locationBaseUrl}/locations/subcomapanydelete`, payload, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLoading(false);
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess("Sub-company Delete successfully.");
          handleListData();
          navigate("/sub-company-list");
        } else {
          toastError("Something went wrong.");
        }
      })
      .catch(() => {
        setLoading(false);
        toastError("Server error.");
      });
  };

  // Table Data
  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ID",
      size: 120,
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={(theme) => ({
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            fontWeight: "700",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
          })}
          onClick={() => navigate(`/sub-company/${row.original.ID}`)}
        >
          {row.original.ID}
        </Box>
      ),
      filterFn: "contains",
    },
    {
      header: "Name",
      accessorKey: "Name",
      // size:"100",
    },
    {
      header: "Location ID",
      accessorKey: "LocationID",
    },
  ]);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Locations List</li>
              </ul>
              {/* </div> */}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "20px",
            }}
          >
            <div className="col-md-4"></div>
            <div>
              <div className="btn-group pull-right ms-2">
                <button
                  type="button"
                  className="btn btn-sm btn-outline-dark d-none"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  More
                </button>
                {/* {checkUserPermission(PERMISSION_DELETED_LOCATIONS) && (
                  <>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-dark dropdown-toggle me-1"
                      data-bs-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{ borderRadius: "5px" }}
                    >
                      More &nbsp;
                    </button>
                    <div className="dropdown-menu">
                      <li>
                        <Link class="dropdown-item" to="/deleted-locations">
                          Manage Deleted Locations
                        </Link>
                      </li>
                    </div>
                  </>
                )} */}
              </div>
              {/* {checkUserPermission(PERMISSION_ADD) && ( */}
                <Link
                  className="btn btn-primary btn-sm pull-right"
                  style={{ width: "max-content" }}
                  to={`/sub-company`}
                >
                  <i className="fa fa-plus me-2 lg"></i>
                  New Sub-Company
                </Link>
              {/* )} */}
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <MaterialReactTable
                  columns={columns}
                  //  title="Deleted Customer List"
                  data={data}
                  // positionPagination='top'
                  enableColumnResizing
                  enableGrouping
                  enableStickyHeader
                  enableStickyFooter
                  enableRowSelection
                  enableColumnOrdering
                  enableRowActions={
                    checkUserPermission(PERMISSION_EDIT) ||
                    checkUserPermission(PERMISSION_DELETE)
                  }
                  positionGlobalFilter="left"
                  renderRowActionMenuItems={({ row, table }) => [
                    <MenuItem
                      key="edit"
                      onClick={() =>
                        navigate(`/sub-company/${row.original.ID}`)
                      }
                    >
                      {/* <EditIcon /> */}
                      Edit
                    </MenuItem>,

                    <MenuItem
                      className="confirm-text"
                      to="#"
                      key="delete"
                      onClick={() => {
                        handleDeletePopup(row.original.ID);
                        
                      }}
                    >
                      Delete
                    </MenuItem>,
                  ]}
                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "1rem",
                        p: "0.5rem",
                        flexWrap: "wrap",
                      }}
                    >
                      {console.log(table, "tables")}

                      {/* {checkUserPermission(PERMISSION_DELETE) ? (
                        <Button
                          // size="small"
                          className="btn btn-sm btn-secondary"
                          style={{ display: "flex" }}
                          disabled={
                            !table.getIsSomeRowsSelected() &&
                            !table.getIsAllRowsSelected()
                          }
                          onClick={() =>
                            handleDeletePopup(
                              "",
                              table.getSelectedRowModel().rows,
                              "multipleRowInactive"
                            )
                          }
                          startIcon={<DeleteIcon />}
                          variant="contained"
                        >
                          Delete Selected
                        </Button>
                      ) : (
                        ""
                      )} */}
                    </Box>
                  )}
                  muiTableBodyProps={{
                    sx: () => ({
                      "& tr:nth-of-type(even)": {
                        backgroundColor:
                          "var(--datatable-row-background-color)",
                        //'rgb(237 237 233 / 63%)'
                      },
                      "& td": {
                        borderRight:
                          "1px solid var(--datatable-row-background-hover-color)",
                        lineHeight: "16px",
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "var(--primary-color-800)",
                        fontFamily: "Inter",
                      },

                      "& tr": {
                        lineHeight: "16px",
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "var(--primary-color-800)",
                        fontFamily: "Inter",
                      },
                    }),
                  }}
                  muiTableContainerProps={{
                    sx: { maxHeight: "fit-content" },
                  }}
                  initialState={{
                    density: "compact",
                    showGlobalFilter: true,
                    expanded: true, //expand all groups by default
                    // grouping: [""], //an array of columns to group by by default (can be multiple)
                    pagination: { pageIndex: 0, pageSize: 10 },
                    // sorting: { id: "Name", desc: false }, //sort by state by default
                  }}
                  muiPaginationProps={{
                    rowsPerPageOptions: [10, 25, 50, 100, 300],
                  }}
                  manualPagination
                  manualSorting
                  muiToolbarAlertBannerProps={
                    isError
                      ? {
                          color: "error",
                          children: "Error loading data",
                        }
                      : undefined
                  }
                  // onColumnFiltersChange={setColumnFilters} // for termp comment filteron column
                  muiTableHeadCellProps={{
                    sx: (theme) => ({
                      background: "var(--datatable-row-background-color)", //'#e9e9e9',
                      borderRight:
                        "1px solid var(--datatable-row-background-hover-color)",
                      lineHeight: "16px",
                      fontWeight: "500",
                      fontSize: "14px",
                      color: "var(--primary-color-800)",
                      fontFamily: "Inter",
                    }),
                  }}
                  onGlobalFilterChange={setGlobalFilter}
                  onPaginationChange={setPagination}
                  onSortingChange={setSorting}
                  rowCount={rowCount}
                  state={{
                    // columnFilters, // for termp comment filteron column
                    globalFilter,
                    filtertext,
                    isLoading,
                    pagination,
                    showAlertBanner: isError,
                    showProgressBars: isRefetching,
                    sorting,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <DeleteConfirmationModal
        deleteApiUrl={`${config.locationBaseUrl}/locations/delete`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />
    </>
  );
};

export default ManageSubCompany;
